import ReviewDecisionModal from './ReviewDecisionModal';

import PortalButton from './PortalButton';
import React, { useState } from 'react';
import { MdVisibility, MdEdit } from 'react-icons/md';
import { usePortalMutation, usePortalDocumentPreview } from '../hooks';
import { ErrorNotice, Status } from './Feedback';
export default function DocumentReview({ application, document, inline = false }) {
  const [reviewing, setReviewing] = useState(false);
  const [reason, setReason] = useState('');
  const decision = usePortalMutation(
      `inscricoes/${application.id}/documentos/${document.id}/decisao`
    ),
    preview = usePortalDocumentPreview(`inscricoes/${application.id}/documentos/${document.id}/visualizar`);
  return (
    <div className="portal-admin-document">
      <div className="portal-admin-row">
        <div>
          <h3>{document.requirement?.title || document.file_name}</h3>
          <Status value={document.status} />
        </div>
        <PortalButton
          className="btn btn-secondary hidethis"
          disabled={preview.isLoading || !preview.allowed}
          onClick={() => {
            const tab = window.open('', '_blank');
            if (tab) tab.opener = null;
            preview.mutate(undefined, {
              onSuccess: url => {
                if (tab) tab.location.replace(url);
                else window.location.assign(url);
              },
              onError: () => { if (tab) tab.close(); },
            });
          }}
          type="button"
        >
          <MdVisibility /> Visualizar documento
        </PortalButton>
      </div>
      <p>{document.file_name}</p>
      {document.reason && <p>{document.reason}</p>}
      <ErrorNotice error={preview.error} />
      {inline && <ErrorNotice error={decision.error} />}
      {['under_review', 'documents_pending', 'rejected'].includes(application.status) && (
        <>
          {inline ? <>
            <label className="form-label">
              <span>Justificativa do documento <small className="text-muted">(opcional)</small></span>
              <textarea className="form-control" rows={2} maxLength={5000} value={reason}
                disabled={!decision.allowed || decision.isLoading} onChange={event => setReason(event.target.value)} />
            </label>
            <div className="portal-admin-actions actions-group portal-document-review-actions">
              <PortalButton className="btn btn-success" disabled={!decision.allowed || decision.isLoading || document.status === 'approved'}
                onClick={() => decision.mutate({ status: 'approved', reason })}>Aprovar documento</PortalButton>
              <PortalButton className="btn btn-danger" disabled={!decision.allowed || decision.isLoading || document.status === 'rejected'}
                onClick={() => decision.mutate({ status: 'rejected', reason })}>Recusar documento</PortalButton>
            </div>
          </> : <>
          <PortalButton
            className="btn btn-info"
            disabled={!decision.allowed}
            onClick={() => {
              decision.reset();
              setReviewing(true);
            }}
          >
            <MdEdit /> Analisar documento
          </PortalButton>
          {reviewing && (
            <ReviewDecisionModal
              title="Analisar documento"
              description={document.requirement?.title || document.file_name}
              mutation={decision}
              onClose={() => setReviewing(false)}
              options={[
                ['approved', 'Aprovar documento'],
                ['rejected', 'Recusar documento'],
              ]}
              minLength={3}
              maxLength={5000}
              reasonRequired={false}
            />
          )}
          </>}
        </>
      )}
    </div>
  );
}
